// Drill-down detail — the per-group "why", opened from a table row. The weekly
// series is fetched lazily by the parent; this just reflects whichever state
// that fetch is in.
import './DataQaDetailModal.scss';
import { Modal } from 'react-bootstrap';
import { Spinner } from '@Components/Spinner';
import { DataQaGroup, DataQaThresholds } from '../../dataQaContract';
import { tacticLabel } from '../data-qa-copy';
import { SeriesState } from '../data-qa-utils';
import { LadderChips } from './LadderChips';
import { PlatformLogo } from './PlatformLogo';
import { ScoreCard } from './ScoreCard';
import { GroupSeriesCharts } from './SeriesChart';

export const DataQaDetailModal = ({
  group,
  thresholds,
  series,
  hasSeriesFile,
  onHide
}: {
  group: DataQaGroup | null;
  thresholds: DataQaThresholds;
  series: SeriesState;
  hasSeriesFile: boolean;
  onHide: () => void;
}) => {
  const sg = group && series.status === 'ready' ? series.data.groups[group.id] : undefined;
  return (
    <Modal size='xl' show={Boolean(group)} onHide={onHide} className='dq-detail-modal'>
      {group && (
        <>
          <Modal.Header closeButton>
            <Modal.Title>
              <PlatformLogo platform={group.platform} />
              <span className='dq-modal-title-text'>
                {group.channel} · {tacticLabel(group.tactic)} · {group.kpi}
              </span>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className='dq-detail' data-testid='dq-detail'>
              <div className='dq-detail-col'>
                <ScoreCard g={group} thresholds={thresholds} />
                <h4>Available grains</h4>
                <LadderChips
                  label='Forecast'
                  ladder={group.path.forecast.ladder}
                  thresholds={thresholds}
                />
                <LadderChips
                  label='Scaling'
                  ladder={group.path.scaling.ladder}
                  thresholds={thresholds}
                />
              </div>
              <div className='dq-detail-col dq-chart-col'>
                {!hasSeriesFile && (
                  <p className='dq-chart-caption'>
                    This QA run predates time-series export — charts will appear on the next run.
                  </p>
                )}
                {series.status === 'loading' && (
                  <div className='dq-chart-state'>
                    <Spinner />
                  </div>
                )}
                {series.status === 'error' && (
                  <p className='dq-chart-caption'>
                    Couldn&rsquo;t load the time series for this run.
                  </p>
                )}
                {series.status === 'ready' &&
                  (sg ? (
                    <GroupSeriesCharts sg={sg} kpi={group.kpi} stale={group.status.scaling.stale} />
                  ) : (
                    <p className='dq-chart-caption'>No time series for this group.</p>
                  ))}
              </div>
            </div>
          </Modal.Body>
        </>
      )}
    </Modal>
  );
};
